import { LogoView } from "../Components/Views/LogoView";
import { ViewItem } from "../Components/Views/ViewItem";
import { LoaderController } from "../Controllers/LoaderController";


class MainLoader extends ViewItem {

    get controller(): LoaderController{
        return this.props.controller
    }
    render(){
        const { loading } = this.controller
        // const loading = true
        return <div className={`main-loader ${loading ? 'loading-on' : 'loading-off'}`}>
                {/* <div className="wow-bg loader-bg">
                </div> */}
                <div className="circle-logo">
                    <LogoView/>
                </div>
            </div>
    }
}

export { MainLoader }